<template>
  <div
    class="color-selector"
    :class="{ 'color-selector--all-genders': allGenders }"
    @mouseover="onMouseevent(true)"
    @mouseleave="onMouseevent(false)"
  >
    <div
      class="color-selector__gender"
      :class="{ 'color-selector__gender--zero-results': maleVariants.length === 0 }"
      v-show="allGenders"
    >
      {{ $t('filter.gender_male') }}
    </div>

    <ColorBox
      v-for="(variant, index) in maleVariants"
      :variant="variant"
      :key="'m-' + index"
      :onColorSelect="onColorSelect"
      :currentVariantId="currentVariantId"
    />
    <div
      class="color-selector__gender"
      :class="{ 'color-selector__gender--zero-results': femaleVariants.length === 0 }"
      v-show="allGenders"
    >
      {{ $t('filter.gender_female') }}
    </div>
    <ColorBox
      v-for="(variant, index) in femaleVariants"
      :variant="variant"
      :key="'f-' + index"
      :onColorSelect="onColorSelect"
      :currentVariantId="currentVariantId"
    />
    <div
      class="color-selector__gender"
      :class="{ 'color-selector__gender--zero-results': unisexVariants.length === 0 }"
      v-show="allGenders"
    >
      {{ $t('filter.all_genders') }}
    </div>
    <ColorBox
      v-for="(variant, index) in unisexVariants"
      :variant="variant"
      :key="'u-' + index"
      :onColorSelect="onColorSelect"
      :currentVariantId="currentVariantId"
    />
  </div>
</template>

<script>
import ColorBox from '../ColorBox.vue'

export default {
  name: 'ColorSelector',
  components: { ColorBox },

  props: {
    variants: {
      type: Array,
      required: true,
    },

    currentVariantId: {
      type: Number,
      required: true,
    },

    onColorSelect: {
      type: Function,
      required: true,
    },

    onMouseevent: {
      type: Function,
      required: false,
      default: null,
    },

    isShowingGenderLabels: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      maleVariants: [],
      femaleVariants: [],
      unisexVariants: [],
    }
  },

  computed: {
    allGenders() {
      // Wait until filter store is ready
      return this.$store.state.filter !== undefined && this.hasGenderFilter
        ? this.$store.state.filter.variantFilters.selected.gender.includes('') ||
            this.$store.state.nav.currentAdditionalNav === 'search' ||
            this.isShowingGenderLabels
        : true
    },
    hasGenderFilter() {
      return this.$store.state.filter.variantFilters.selected.gender !== undefined
    },
  },

  created() {
    this.separateGenderVariants()
  },

  methods: {
    separateGenderVariants() {
      this.variants.forEach(variant => {
        if (variant.gender.length === 1) {
          variant.gender.some(v => ['mens', 'men'].includes(v))
            ? this.maleVariants.push(variant)
            : this.femaleVariants.push(variant)
        } else {
          // Unisex variants contain both "mens" and "womens" gender
          this.unisexVariants.push(variant)
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import './color-selector';
</style>
